import { Idea, IdeaMenuAction, IdeaMenuActionId, IdeaStatus, Status } from "@/models"

const openIdeaStatus = new Status({ id: "OPEN", label: "Open" })
const convertedIdeaStatus = new Status({ id: "CONVERTED", label: "Converted" })
const obsoleteIdeaStatus = new Status({ id: "OBSOLETE", label: "Obsolete" })
const doneIdeaStatus = new Status({ id: "DONE", label: "Done" })
const restoreIdeaStatus = new Status({ id: "OPEN", label: "Restore" })

export function getIdeaStatus(status: IdeaStatus): Status {
  if (status === "CONVERTED") return convertedIdeaStatus
  if (status === "OBSOLETE") return obsoleteIdeaStatus
  if (status === "DONE") return doneIdeaStatus
  return openIdeaStatus
}

export interface IdeaStatusOption {
  status: IdeaStatus
  badge: Status
}

const obsoleteIdeaOption: IdeaStatusOption = { status: "OBSOLETE", badge: obsoleteIdeaStatus }
const restoreIdeaOption: IdeaStatusOption = { status: "OPEN", badge: restoreIdeaStatus }

export function getIdeaStatusOptions({
  status,
  obsoleteByConvertedResource
}: Pick<Idea, "status" | "obsoleteByConvertedResource">): IdeaStatusOption[] {
  if (status === "OPEN") return [obsoleteIdeaOption]
  if (status === "OBSOLETE" && !obsoleteByConvertedResource) return [restoreIdeaOption]
  return []
}

const deleteIdeaMenuAction: IdeaMenuAction = { id: "delete", label: "Delete Idea" }

const openIdeaMenuActions: IdeaMenuAction[] = [
  { id: "convertRoadmapFeature", label: "Promote to Roadmap Deliverable" },
  { id: "convertEpic", label: "Convert to Epic" },
  { id: "convertBacklog", label: "Convert to Backlog Item" },
  { ...deleteIdeaMenuAction, divider: true }
]
const closedIdeaMenuActions: IdeaMenuAction[] = [deleteIdeaMenuAction]

export function getIdeaMenuActions(status: IdeaStatus): IdeaMenuAction[] {
  return status === "OPEN" ? openIdeaMenuActions : closedIdeaMenuActions
}

export interface IdeaActionConfirmContent {
  title: string
  body: string
  confirmLabel: string
  danger?: boolean
}

export const ideaActionConfirmContent: Partial<Record<IdeaMenuActionId, IdeaActionConfirmContent>> =
  {
    convertRoadmapFeature: {
      title: "Promote Idea to Roadmap Deliverable",
      body: "This idea will be added to the Roadmap as a Later Deliverable.\nThis action cannot be undone. Do you want to continue?",
      confirmLabel: "Promote"
    },
    convertEpic: {
      title: "Convert Idea to Epic",
      body: "This will create an Epic from this idea.\nThis action cannot be undone. Do you want to continue?",
      confirmLabel: "Convert"
    },
    convertBacklog: {
      title: "Convert Idea to Backlog Item",
      body: "This will create a Backlog Item from this idea.\nThis action cannot be undone. Do you want to continue?",
      confirmLabel: "Convert"
    },
    delete: {
      title: "Delete Idea",
      body: "Click delete button below to confirm.",
      confirmLabel: "Delete",
      danger: true
    }
  }
